/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { ShopPerformance } from './ShopPerformance';
import {
    ShopPerformanceFromJSON,
    ShopPerformanceFromJSONTyped,
    ShopPerformanceToJSON,
    ShopPerformanceToJSONTyped,
} from './ShopPerformance';

/**
 * 
 * @export
 * @interface ShopPerformanceDimensionRow
 */
export interface ShopPerformanceDimensionRow {
    /**
     * 
     * @type {string}
     * @memberof ShopPerformanceDimensionRow
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShopPerformanceDimensionRow
     */
    name?: string;
    /**
     * 
     * @type {ShopPerformance}
     * @memberof ShopPerformanceDimensionRow
     */
    performance?: ShopPerformance;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof ShopPerformanceDimensionRow
     */
    partialProfitability?: PartialProfitabilityData | null;
}

/**
 * Check if a given object implements the ShopPerformanceDimensionRow interface.
 */
export function instanceOfShopPerformanceDimensionRow(value: object): value is ShopPerformanceDimensionRow {
    return true;
}

export function ShopPerformanceDimensionRowFromJSON(json: any): ShopPerformanceDimensionRow {
    return ShopPerformanceDimensionRowFromJSONTyped(json, false);
}

export function ShopPerformanceDimensionRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopPerformanceDimensionRow {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'performance': json['performance'] == null ? undefined : ShopPerformanceFromJSON(json['performance']),
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
    };
}

export function ShopPerformanceDimensionRowToJSON(json: any): ShopPerformanceDimensionRow {
    return ShopPerformanceDimensionRowToJSONTyped(json, false);
}

export function ShopPerformanceDimensionRowToJSONTyped(value?: ShopPerformanceDimensionRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'performance': ShopPerformanceToJSON(value['performance']),
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
    };
}

